<template>
  <div class="upload-file">
    <Upload
      ref="upload"
      :action="uploadURL"
      :headers="uploadHeaders"
      :show-upload-list="showUploadList"
      :before-upload="beforeUpload"
      :on-success="onUploadSuccess"
      :on-error="onUploadError"
      :on-format-error="onFormatError"
      :format="format"
      :data="data"
    >
      <Button type="primary" icon="ios-add" v-if="primary&&showIcon">{{label}}</Button>
      <Button v-else-if="!primary&&showIcon" icon="ios-add">{{label}}</Button>
      <Button type="primary" v-else-if="primary&&!showIcon">{{label}}</Button>
      <Button v-else-if="!primary&&!showIcon">{{label}}</Button>
      <p v-if="note" class="note">{{note}}</p>
    </Upload>
  </div>
</template>

<script>
const buildConfig = require("../build/" + process.env.BUILD_ENV + ".js");

export default {
  name: "upload-file",
  props: {
    url: {
      type: String,
      required: true
    },
    format: {
      type: Array,
      default() {
        return [];
      }
    },
    label: {
      type: String,
      default: "选择文件"
    },
    primary: {
      type: Boolean,
      default: true
    },
    note: {
      type: String,
      defalut: ""
    },
    showIcon: {
      type: Boolean,
      default: true
    },
    data: {
      type: Object
    }
  },
  data() {
    return {
      uploadURL: buildConfig.BASE_URL + this.url,
      uploadHeaders: {
        Authorization: "Bearer " + localStorage.adminToken
      },
      event: {
        onSuccess: "onSuccess",
        onError: "onError"
      },
      showUploadList: false
    };
  },
  methods: {
    init() {
      this.$refs.upload.clearFiles();
    },
    onUploadSuccess(res) {
      this.init();
      if (res.code == 200) {
        this.$emit(this.event.onSuccess, res.data);
      } else {
        this.$Message.error(res.msg);
      }
    },
    onUploadError(err) {
      this.$emit(this.event.onError, err);
      this.init();
    },
    onFormatError() {
      this.init();
      if (this.format.length == 0) return;
      let formats = "";
      this.format.forEach(i => {
        formats += i + "/";
      });
      formats = formats.slice(0, -1);
      this.$Message.error("文件格式只能为：" + formats);
    },
    beforeUpload() {
      this.showUploadList = true;
    }
  }
};
</script>